import React, { FunctionComponent } from "react";
import OverflowTooltip from "components/molecules/tooltip/OverflowTooltip";
import { useIntl } from "react-intl";
import { intlUtils } from "utils/intlUtils";
import { formatToEuro } from "constants/intl/number/format";
import { IBaseCellProps } from "interfaces/table/table";
import { activityUtils } from "utils/business/activityUtils";

export const TableCell: FunctionComponent<IBaseCellProps> = ({ value, style, type, defaultValue }) => {
  const intl = useIntl();
  let formattedValue = value;
  switch (type) {
    case "money":
      formattedValue = value ? intlUtils.formatNumber(intl, parseFloat(value), formatToEuro) : defaultValue ?? "";
      break;
    case "date":
      formattedValue = value ? intl.formatDate(value) : defaultValue ?? "";
      break;
    case "dateTime":
      formattedValue = value ? intl.formatTime(value) : defaultValue ?? "";
      break;
    case "capitalize":
      formattedValue = value?.toLowerCase();
      break;
    case "transformDate":
      const activity = activityUtils.formatDateLastActivity(value ? new Date(value) : null);
      formattedValue = intl.formatMessage({ id: activity.interval.label }, { interval: activity.number });
      break;
    case "percent":
      formattedValue = value ? (+value).toFixed(2) + " %" : defaultValue ?? "";
      break;
    default:
  }
  return (
    <div style={{ height: "100%", ...style }} className="flex flex-col-center">
      <OverflowTooltip resizeClass="resizer">{formattedValue}</OverflowTooltip>
    </div>
  );
};
